import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { useSelector } from 'react-redux';

import { Cell } from '@/App/BulkOrder/BulkOrderTables/Cell.tsx';
import { OrderStatus } from '@/App/BulkOrder/BulkOrderTables/OrderStatus.tsx';
import { WayCell } from '@/App/BulkOrder/BulkOrderTables/WayCell.tsx';
import { fixingBulkOrderSelector } from '@/store/bulkOrder/selectors.ts';

type OrderRowProps = {
  orderId: string;
  tabId: string;
};

export const FixingOrderRow = (props: OrderRowProps) => {
  const { orderId, tabId } = props;

  const order = useSelector((state) => fixingBulkOrderSelector(state, tabId, { orderId }));

  return (
    <tr data-e2e={`row-${order?.properties.currencyPair.replaceAll('/', '-')}-${order?.properties.bdrId}`}>
      <td width="120" align="left" data-e2e="status-cell">
        <OrderStatus status={order?.properties.status} errors={order?.properties.errors} />
      </td>

      <td width="140" align="left" className="text-success" data-e2e="status-oms-id-cell">
        <strong>{order?.properties.omsId}</strong>
      </td>

      <Cell width="120" field="bdrId" errors={order?.properties.errors} align="left">
        {order?.properties.bdrId}
      </Cell>

      <Cell width="120" field="currencyPair" errors={order?.properties.errors} align="left">
        {order?.properties.currencyPair}
      </Cell>

      <WayCell way={order?.properties.way} width="120" field="way" errors={order?.properties.errors} align="left">
        <FormattedMessage id={order?.properties.way === 'Ask' ? 'way.buy' : 'way.sell'} />
      </WayCell>

      <Cell width="200" field="notional" errors={order?.properties.errors} align="right">
        <FormattedNumber value={order?.properties.notional ?? 0} />
        &nbsp;{order?.properties.currency}
      </Cell>
      <Cell width="120" field="fixingReference" errors={order?.properties.errors} align="left">
        {order?.properties.fixingReference}
      </Cell>

      <Cell width="120" field="fixingPriceType" errors={order?.properties.errors} align="left">
        {order?.properties.fixingPriceType}
      </Cell>

      <Cell width="250" field="fixingDateUtc" errors={order?.properties.errors} align="left">
        {order?.properties.fixingDateUtc !== undefined ? (
          <FormattedDate
            value={order?.properties.fixingDateUtc}
            year="numeric"
            month="long"
            day="2-digit"
            hour="2-digit"
            minute="2-digit"
          />
        ) : (
          ''
        )}
      </Cell>

      <Cell width="250" field="deliveryDate" errors={order?.properties.errors} align="left">
        {order?.properties.deliveryDate !== undefined ? (
          <FormattedDate
            value={order?.properties.deliveryDate}
            year="numeric"
            month="long"
            day="2-digit"
            hour="2-digit"
            minute="2-digit"
            timeZone="UTC"
          />
        ) : (
          ''
        )}
      </Cell>

      <Cell width="120" field="fixingPlace" errors={order?.properties.errors} align="left">
        {order?.properties.fixingPlace}
      </Cell>
      <Cell width="120" field="fixingTime" errors={order?.properties.errors} align="left">
        {order?.properties.fixingTime}
      </Cell>
      <Cell width="120" field="fixingMarginType" errors={order?.properties.errors} align="left">
        {order?.properties.fixingMarginType}
      </Cell>
      <Cell field="commercialMargin" errors={order?.properties.errors} align="left">
        {order?.properties.commercialMargin}
      </Cell>
    </tr>
  );
};
